import React from 'react';
import moment from 'moment';
import SMConst from 'lib/SMConst';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMOwnerHelper from 'components/helpers/SMOwnerHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMOwnerSummaryView extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }
  
  showInquiryForm(e){
    this.props.delegate.showInquiryForm(e);
  }
  
  render() {

    const owner = this.props.owner;
    const createdAt = moment(owner.created_at).format("YYYY/MM/DD");
    let authRows = [];

    if (owner.is_verified_facebook) {
      authRows.push(<li key="facebook"><i className="fa fa-check"></i>{I18n.t("dashboard.label_000098")}</li>);
    }
    if (owner.is_verified_email) {
      authRows.push(<li key="email"><i className="fa fa-check"></i>{I18n.t("dashboard.label_000095")}</li>);
    }
    if (owner.is_verified_tel) {
      authRows.push(<li key="tel"><i className="fa fa-check"></i>{I18n.t("dashboard.label_000096")}</li>);
    }
        
    let goldSuperHost = null;
    let goldSuperHostDescription = null;
    if (owner.rank && owner.rank == SMConst.OwnerRank.SuperHost) {
      goldSuperHost = <img src={SMRailsBridge.assetPath.goldSuperHost} alt="トップホスト" className="space-main__owner-superhost" />;
      goldSuperHostDescription = 
        <div className="mod-host__superhost-area">
          <div className="mod-host__superhost-text">
            <img src={SMRailsBridge.assetPath.goldSuperHost} alt="トップホスト" />トップホスト<i className="fa fa-question-circle"></i>
            <span className="mod-tooltip mod-host__superhost__help-tooltip">
              <span className="baloon baloon-top user-detail-baloon mod-tooltip__detail mod-host__superhost__help-baloon">
                <span className="baloon-inner">トップホストとは、スペースマーケットの設定する条件をクリアした優良ホストに対して送られる称号です。
                  <span className="mod-host__superhost-notes">
                    <a href={SMAppHelper.helpUrl(SMConst.CommonHelpPageID.AboutTopHost)} className="a__underline">もっと詳しく</a>
                  </span>
                </span>
              </span>
            </span>
          </div>
        </div>;
    }
    
    const evaluateConfirmRate = SMOwnerHelper.ownerEvaluationImage(owner.confirm_rate_evaluation);
    const evaluateReplyRate = SMOwnerHelper.ownerEvaluationImage(owner.reply_rate_evaluation);
    const evaluateReplyTimeAvg = SMOwnerHelper.ownerEvaluationImage(owner.reply_time_avg_evaluation);

    return(
      <div className="col-sm-12 col-md-8">
        <h2 className="page-subtitle">このスペースの管理者</h2>
          <div className="mb20">
          <div className="space-main__host">
            <div className="mod-host__icon-inner">
              <a href={Routes.owner_path(owner.username)}><img src={owner.profile_image} alt="" className="is-hover space-main__host-icon" /></a>
              {goldSuperHost}
            </div>
            <p className="space-main__host-date">{I18n.t("service.label_000005")}<span className="space-main__host-date-days">{createdAt}</span></p>
            {goldSuperHostDescription}
          </div>
          <div className="space-main__host-detail">
            <h3 className="space-main__host-name link__subcolor"><a href={Routes.owner_path(owner.username)}>{SMFormatHelper.ownerName(owner)}</a></h3>
            {(()=>{
              if (!this.props.canInquiry) return null;
              return (
                <p className="space-main__host-contact"><a href="#" onClick={this.showInquiryForm.bind(this)} className="a__underline">メッセージを送る</a></p>
              );
            })()}
            <div className="space-main__host-evaluate clearfix">
              <div className="space-main__host-evaluate-list">
                <h4 className="mod-evaluate__title">{I18n.t("service.label_000058")}
                  <span className="mod-evaluate__help">
                    <i className="fa fa-question-circle mod-evaluate__question"></i>
                    <span className="mod-tooltip mod-evaluate__help-tooltip">
                      <span className="baloon baloon-top user-detail-baloon mod-tooltip__detail mod-evaluate__help-baloon">
                        <span className="baloon-inner">予約リクエストが承認された実績等を元に、スペースマーケットが算出した表記です。</span>
                      </span>
                    </span>
                  </span>
                </h4>
                <div className="mod-evaluate__value">
                  <img src={evaluateConfirmRate} alt="" className="mod-evaluate__value-img" />
                  <span className="mod-evaluate__value-text">{owner.confirm_rate_text}</span>
                </div>
              </div>
              <div className="space-main__host-evaluate-list">
                <h4 className="mod-evaluate__title">{I18n.t("service.label_000006")}</h4>
                <div className="mod-evaluate__value">
                  <img src={evaluateReplyRate} alt="" className="mod-evaluate__value-img" />
                  <span className="mod-evaluate__value-text">{owner.reply_rate_text}</span>
                </div>
              </div>
              <div className="space-main__host-evaluate-list">
                <h4 className="mod-evaluate__title">{I18n.t("service.label_000007")}</h4>
                <div className="mod-evaluate__value">
                  <img src={evaluateReplyTimeAvg} alt="" className="mod-evaluate__value-img" />
                  <span className="mod-evaluate__value-text">{owner.reply_time_avg_text}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="row">
          <div className="col-xs-12">
            <p className="space-main__host-text">{owner.profile}</p>
            <p className="mod-more space-main__host-text"><a href={Routes.owner_path(owner.username)}>{I18n.t("service.label_000008")}</a></p>
          </div>
          <div className="col-xs-12">
            <div className="space-main__authentication clearfix">
              <div className="col-xs-3 col-sm-2 ta-c">
                <img className="space-main__authentication-icon" src={SMRailsBridge.assetPath.certificationMark} alt={I18n.t("service.label_000010")} />
              </div>
              <div className="col-xs-9 col-sm-10">
                <h4 className="space-main__authentication-headline">{I18n.t("service.text_000002")}</h4>
                <ul className="space-main__authentication-check">
                  {authRows}
                </ul>
              </div>
            </div>
            {/*<p className="mt20 mb10 pc-hide__sm-show"><a href="#" onClick={this.showInquiry.bind(this)} className="space-side__buttons-link"><i className="fa fa-envelope"></i>お問い合わせ</a></p>*/}
          </div>
        </div>
      </div>
    );
  }

}
export default SMOwnerSummaryView;



// WEBPACK FOOTER //
// ./app/javascript/components/owners/SMOwnerSummaryView.jsx